import { Tag } from 'antd';
import React from 'react';
import { AppColors } from '../Utils/helper/AppColors';

const DEPARTMENT_TYPE = {
	DESIGN: {
		label: 'Design',
		color: 'purple',
	},
	PRODUCT: {
		label: 'Product',
		color: 'blue',
	},
	MARKETING: {
		label: 'Marketing',
		color: 'geekblue',
	},
	SOFTWARE: {
		label: 'Software Engineering',
		color: 'green',
	},
	FINANCE: {
		label: 'Finance',
		color: 'geekblue',
	},
	OPERATIONS: {
		label: 'Operations',
		color: 'pink',
	},
	CUSTOMER_SUCCESS: {
		label: 'Customer Success',
		color: 'blue',
	},
};

export default function DepartmentTag({ department }) {
	return (
		// DEPARTMENT_TYPE[department] && (
		// 	<Tag style={{ borderRadius: 50, margin: 0 }} color={DEPARTMENT_TYPE[department]?.color || 'blue'}>
		// 		{DEPARTMENT_TYPE[department]?.label || department}
		// 	</Tag>
		// )

		<Tag
			style={{
				borderRadius: 30,
				margin: 0,
				backgroundColor: AppColors.LIGHTEST_SHADE, // Background color
				color: AppColors.DARKER_PRIMARY, // Text color
                fontSize: 8,
				fontWeight: 500,
				lineHeight: '121%',
				fontFamily: 'Poppins',
				padding: '4px 8px',
			}}
		>
			{department}
		</Tag>
	);
}
